"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerationErrorToJSON = exports.GenerationErrorFromJSONTyped = exports.GenerationErrorFromJSON = exports.instanceOfGenerationError = exports.GenerationErrorNameEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.GenerationErrorNameEnum = {
    NotAnAd: 'ERROR_NOT_AN_AD',
    OffTopic: 'ERROR_OFF_TOPIC',
    Nonsense: 'ERROR_NONSENSE',
    SensitiveTopic: 'ERROR_SENSITIVE_TOPIC',
    GuardrailTopic: 'ERROR_GUARDRAIL_TOPIC',
    DurationOutOfRange: 'ERROR_DURATION_OUT_OF_RANGE'
};
/**
 * Check if a given object implements the GenerationError interface.
 */
function instanceOfGenerationError(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfGenerationError = instanceOfGenerationError;
function GenerationErrorFromJSON(json) {
    return GenerationErrorFromJSONTyped(json, false);
}
exports.GenerationErrorFromJSON = GenerationErrorFromJSON;
function GenerationErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'topics': !(0, runtime_1.exists)(json, 'topics') ? undefined : json['topics'],
    };
}
exports.GenerationErrorFromJSONTyped = GenerationErrorFromJSONTyped;
function GenerationErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'topics': value.topics,
    };
}
exports.GenerationErrorToJSON = GenerationErrorToJSON;
